const transformServices = (categories, override) =>
  categories.reduce((previous, current) => {
    previous[current.id] = current.services.reduce((prev, curr) => {
      prev[curr.id] = typeof override === 'boolean' ? override : curr.accepted;
      return prev;
    }, {});

    return previous;
  }, {});

export default transformServices;
